import { TicketingFormCategory } from "./ticketing";
export var ReferralQuestionChoice;
(function (ReferralQuestionChoice) {
    ReferralQuestionChoice["ReferralFromOrganization"] = "ReferralFromOrganization";
    ReferralQuestionChoice["ReferralFromDonor"] = "ReferralFromDonor";
    ReferralQuestionChoice["SocialNetwork"] = "SocialNetwork";
    ReferralQuestionChoice["OrganicSearch"] = "OrganicSearch";
    ReferralQuestionChoice["Other"] = "Other";
    ReferralQuestionChoice["Capterra"] = "Capterra";
    ReferralQuestionChoice["AsDonor"] = "AsDonor";
    ReferralQuestionChoice["Nbctc"] = "Nbctc";
})(ReferralQuestionChoice || (ReferralQuestionChoice = {}));
export var ReferralSource;
(function (ReferralSource) {
    ReferralSource["Donor"] = "Donor";
    ReferralSource["FriendFamilyColleague"] = "FriendFamilyColleague";
    ReferralSource["SocialMedia"] = "SocialMedia";
    ReferralSource["SearchEngine"] = "SearchEngine";
    ReferralSource["AI"] = "AI";
    ReferralSource["Nbctc"] = "Nbctc";
    ReferralSource["Other"] = "Other";
    ReferralSource["Capterra"] = "Capterra";
    ReferralSource["ReferredByOrganization"] = "ReferredByOrganization";
    ReferralSource["PodcastOrPress"] = "PodcastOrPress";
    ReferralSource["FromDonorDashboard"] = "FromDonorDashboard";
    ReferralSource["FromOrganizationDashboard"] = "FromOrganizationDashboard";
})(ReferralSource || (ReferralSource = {}));
export var InitialEmailProvider;
(function (InitialEmailProvider) {
    InitialEmailProvider["Mailchimp"] = "Mailchimp";
    InitialEmailProvider["ConstantContact"] = "ConstantContact";
    InitialEmailProvider["Gmail"] = "Gmail";
    InitialEmailProvider["Outlook"] = "Outlook";
    InitialEmailProvider["Other"] = "Other";
})(InitialEmailProvider || (InitialEmailProvider = {}));
export var InitialDonorDataProvider;
(function (InitialDonorDataProvider) {
    InitialDonorDataProvider["DonorManagementPlatform"] = "DonorManagementPlatform";
    InitialDonorDataProvider["GoogleSheetExcel"] = "GoogleSheetExcel";
    InitialDonorDataProvider["NoProvider"] = "NoProvider";
    InitialDonorDataProvider["Other"] = "Other";
})(InitialDonorDataProvider || (InitialDonorDataProvider = {}));
export var SimplykProducts;
(function (SimplykProducts) {
    SimplykProducts["Donation"] = "Donation";
    SimplykProducts["Ticketing"] = "Ticketing";
})(SimplykProducts || (SimplykProducts = {}));
export var EmailContentType;
(function (EmailContentType) {
    EmailContentType["INVITATION"] = "invitation";
    EmailContentType["FOLLOW_UP"] = "followup";
    EmailContentType["BLAST"] = "blast";
    EmailContentType["POST_EVENT"] = "post-event";
    EmailContentType["REMINDER"] = "reminder";
    EmailContentType["EXTRA_THANK_YOU_EMAIL"] = "extra_thank_you_email";
})(EmailContentType || (EmailContentType = {}));
export var FormType;
(function (FormType) {
    FormType["DonationForm"] = "DonationForm";
    FormType["Ticketing"] = "Ticketing";
})(FormType || (FormType = {}));
export var OrganizationCause;
(function (OrganizationCause) {
    OrganizationCause["Nature"] = "Nature";
    OrganizationCause["Solidarity"] = "Solidarity";
    OrganizationCause["SportAndCulture"] = "SportAndCulture";
    OrganizationCause["Education"] = "Education";
})(OrganizationCause || (OrganizationCause = {}));
export var Ratio;
(function (Ratio) {
    Ratio[Ratio["Square"] = 0] = "Square";
    Ratio[Ratio["Landscape"] = 1] = "Landscape";
})(Ratio || (Ratio = {}));
export var OrganizationType;
(function (OrganizationType) {
    OrganizationType["Charity"] = "Charity";
    OrganizationType["Other501C"] = "Other501C";
    OrganizationType["Social"] = "Social";
    OrganizationType["Private"] = "Private";
    OrganizationType["Other"] = "Other";
})(OrganizationType || (OrganizationType = {}));
export var OrganizationCategory;
(function (OrganizationCategory) {
    OrganizationCategory["SocialService"] = "SocialService";
    OrganizationCategory["CommunityService"] = "CommunityService";
    OrganizationCategory["SportsAndLeisure"] = "SportsAndLeisure";
    OrganizationCategory["Culture"] = "Culture";
    OrganizationCategory["Health"] = "Health";
    OrganizationCategory["Veterans"] = "Veterans";
    OrganizationCategory["AnimalWelfare"] = "AnimalWelfare";
    OrganizationCategory["Environment"] = "Environment";
    OrganizationCategory["Education"] = "Education";
    OrganizationCategory["StudentGroup"] = "StudentGroup";
    OrganizationCategory["Religion"] = "Religion";
    OrganizationCategory["Humanitarian"] = "Humanitarian";
    OrganizationCategory["Politic"] = "Politic";
    OrganizationCategory["Other"] = "Other";
})(OrganizationCategory || (OrganizationCategory = {}));
export var DonationFormCategory;
(function (DonationFormCategory) {
    DonationFormCategory["DonationForm"] = "DonationForm";
    DonationFormCategory["PeerToPeerCampaign"] = "PeerToPeerCampaign";
})(DonationFormCategory || (DonationFormCategory = {}));
export var FrequencyFilter;
(function (FrequencyFilter) {
    FrequencyFilter["Daily"] = "Daily";
    FrequencyFilter["Weekly"] = "Weekly";
    FrequencyFilter["Monthly"] = "Monthly";
})(FrequencyFilter || (FrequencyFilter = {}));
export const FormCategory = { ...TicketingFormCategory, ...DonationFormCategory };
export var EmailEditorOpenedFrom;
(function (EmailEditorOpenedFrom) {
    EmailEditorOpenedFrom["DuplicateFromTableRow"] = "DuplicateFromTableRow";
    EmailEditorOpenedFrom["DuplicateFromDrawer"] = "DuplicateFromDrawer";
    EmailEditorOpenedFrom["DuplicateFromCommunicationTab"] = "DuplicateFromCommunicationTab";
    EmailEditorOpenedFrom["ContactPageHeader"] = "ContactPageHeader";
    EmailEditorOpenedFrom["ContactPageEmailRow"] = "ContactPageEmailRow";
    EmailEditorOpenedFrom["CopyEmailInfobox"] = "CopyEmailInfobox";
    EmailEditorOpenedFrom["EmailTemplateWrapper"] = "EmailTemplateWrapper";
    EmailEditorOpenedFrom["ContactPageBulkHeader"] = "ContactPageBulkHeader";
    EmailEditorOpenedFrom["CampaignFormsHeader"] = "CampaignFormsHeader";
    EmailEditorOpenedFrom["UserPageHeader"] = "UserPageHeader";
    EmailEditorOpenedFrom["EmailsHeader"] = "EmailsHeader";
    EmailEditorOpenedFrom["GuestListBulkHeader"] = "GuestListBulkHeader";
    EmailEditorOpenedFrom["VisitorReport"] = "VisitorReport";
    EmailEditorOpenedFrom["EventCommunication"] = "EventCommunication";
    EmailEditorOpenedFrom["PaymentDetailDrawer"] = "PaymentDetailDrawer";
    EmailEditorOpenedFrom["EventCommunicationShortcut"] = "EventCommunicationShortcut";
    EmailEditorOpenedFrom["PaymentPageCampaignHubBulkHeader"] = "PaymentPageCampaignHubBulkHeader";
    EmailEditorOpenedFrom["CampaignTodo"] = "CampaignTodo";
    EmailEditorOpenedFrom["DefaultReminder"] = "DefaultReminder";
    EmailEditorOpenedFrom["ContactListCard"] = "ContactListCard";
    EmailEditorOpenedFrom["FollowupFromEmailDetails"] = "FollowupFromEmailDetails";
})(EmailEditorOpenedFrom || (EmailEditorOpenedFrom = {}));
export const isEmailEditorOpenedFrom = (value) => Object.values(EmailEditorOpenedFrom).includes(value);
export var SuggestedActionType;
(function (SuggestedActionType) {
    SuggestedActionType["Visitor"] = "Visitor";
    SuggestedActionType["TaxReceipt"] = "TaxReceipt";
    SuggestedActionType["ThankBigDonor"] = "ThankBigDonor";
    SuggestedActionType["Import"] = "Import";
    SuggestedActionType["AddUser"] = "AddUser";
    SuggestedActionType["TapToPay"] = "TapToPay";
    SuggestedActionType["FormCommunicationSetup"] = "FormCommunicationSetup";
})(SuggestedActionType || (SuggestedActionType = {}));
export var EmailContentFlow;
(function (EmailContentFlow) {
    /** @deprecated - already phased out, db will be cleaned up soon  */
    EmailContentFlow["Custom"] = "Custom";
    EmailContentFlow["Quick"] = "Quick";
    EmailContentFlow["Builder"] = "Builder";
})(EmailContentFlow || (EmailContentFlow = {}));
export var FormSubmissionStatus;
(function (FormSubmissionStatus) {
    FormSubmissionStatus["Incomplete"] = "Incomplete";
    FormSubmissionStatus["Failed"] = "Failed";
    FormSubmissionStatus["Succeeded"] = "Succeeded";
})(FormSubmissionStatus || (FormSubmissionStatus = {}));
export var ContactSort;
(function (ContactSort) {
    ContactSort["LastName"] = "lower_last_name";
    ContactSort["LastTransactionDate"] = "contact.lastInteractionCreatedAt";
    ContactSort["TotalContribution"] = "contact.totalContribution";
})(ContactSort || (ContactSort = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var DonorType;
(function (DonorType) {
    DonorType["Monthly"] = "Monthly";
    DonorType["Member"] = "Member";
    DonorType["Yearly"] = "Yearly";
    DonorType["Returning"] = "Returning";
    DonorType["OneTime"] = "OneTime";
    DonorType["Prospect"] = "Prospect";
})(DonorType || (DonorType = {}));
/*
  This enum is here to control the value of fieldName that is sent by the client
  We can avoid SQL injections that way since the fieldName cannot be passed as a parameter to the query
  Make sure that this value corresponds to a field alias in the corresponding typeorm query
*/
export var FieldName;
(function (FieldName) {
    FieldName["ContactTableUserId"] = "user.id";
    FieldName["ContactTableLanguage"] = "contact.locale";
    FieldName["ContactTableEmail"] = "user.email";
    FieldName["ContactTableLastPaymentDate"] = "contact.lastInteractionCreatedAt";
    FieldName["ContactTableFirstPaymentDate"] = "contact.firstInteractionCreatedAt";
    FieldName["ContactTableTotalContribution"] = "contact.totalContribution";
    FieldName["ContactTableDonorType"] = "contact.donorType";
    FieldName["ContactTableCompleteName"] = "contact.fullname";
    FieldName["ContactTableCompanyName"] = "commands.corporationName";
    FieldName["ContactTableFormId"] = "commands.formId";
    FieldName["ContactTableTransactionDate"] = "transactions.createdAtUtc";
    FieldName["ContactTableMonthlyDonation"] = "subscriptions.status";
    FieldName["ContactTableRecurringPayment"] = "subscriptions.recurrenceInterval";
    FieldName["ContactTableNoteContent"] = "notes.content";
    FieldName["TicketingTableIsArchived"] = "ticketing.is_archived";
    FieldName["DonationFormTableIsArchived"] = "donationForm.is_archived";
    FieldName["OrderTableCreateAtUtc"] = "order.created_at_utc";
    FieldName["OrderTableTicketingId"] = "order.ticketing_id";
    FieldName["OrderTableOccurrenceId"] = "order.occurrence_id";
    FieldName["OrderTableLocale"] = "order.locale";
    FieldName["OrderTableFirstName"] = "order.first_name";
    FieldName["OrderTableLastName"] = "order.last_name";
    FieldName["OrderTableEmail"] = "order.email";
    FieldName["OrderTableHasUnsubscribed"] = "contacts.hasUnsubscribed";
    FieldName["EmailDeliveryStatus"] = "email_deliveries.status";
    FieldName["CommandTableStatus"] = "command.status";
    FieldName["CommandTableCreatedAtUtc"] = "command.created_at_utc";
    FieldName["ReceiptTableCreatedAtUtc"] = "receipt.created_at_utc";
    FieldName["ReceiptTableDonationDate"] = "receipt.donation_date";
    FieldName["ReceiptTableFirstName"] = "receipt.first_name";
    FieldName["ReceiptTableLastName"] = "receipt.last_name";
    FieldName["ReceiptTableEmail"] = "receipt.email";
    FieldName["ReceiptTableStatus"] = "receipt.status";
    FieldName["AnswersAnswer"] = "answers.answer";
    FieldName["TransactionTableCreatedAtUtc"] = "transaction.created_at_utc";
    FieldName["TransactionTableFirstName"] = "command.first_name";
    FieldName["TransactionTableLastName"] = "command.last_name";
    FieldName["TransactionTableEmail"] = "command.email";
    FieldName["TransactionTableFormId"] = "command.form_id";
    FieldName["ProductTicketAnnotation"] = "product_tickets.annotation";
    FieldName["TransactionTableOccurrence"] = "command.ticketing_occurrence_id";
    FieldName["TransactionTableProductTicketStatus"] = "product_tickets.status";
    FieldName["TransactionTableHasUnsubscribe"] = "has_unsubscribed";
    FieldName["TransactionTableLocale"] = "command.locale";
    // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
    FieldName["InsightsPageTransactionCreatedAtUtc"] = "transaction.created_at_utc";
    // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
    FieldName["InsightsPageFormId"] = "command.form_id";
    FieldName["VisitorTableUserID"] = "command.user_id";
    FieldName["EventManagementTableCommandId"] = "command.id";
    FieldName["TicketStatus"] = "TicketStatus";
    FieldName["GuestListTableRate"] = "product_tickets.rate_id";
    // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
    FieldName["ProductTicketStatus"] = "product_tickets.status";
    FieldName["ReminderEmailStatus"] = "reminder_email.status";
})(FieldName || (FieldName = {}));
export var Sorting;
(function (Sorting) {
    Sorting["TitleAsc"] = "TitleAsc";
    Sorting["TitleDesc"] = "TitleDesc";
    Sorting["VolumeAsc"] = "VolumeAsc";
    Sorting["VolumeDesc"] = "VolumeDesc";
    Sorting["CreationDateDesc"] = "CreationDateDesc";
    Sorting["UpdatedDateDesc"] = "UpdatedDateDesc";
})(Sorting || (Sorting = {}));
export var PaymentSort;
(function (PaymentSort) {
    PaymentSort["Amount"] = "transferrable_amount";
    PaymentSort["Date"] = "transaction.created_at_utc";
    PaymentSort["PurchaserLastName"] = "lower_purchaser_last_name";
})(PaymentSort || (PaymentSort = {}));
export var FormStatus;
(function (FormStatus) {
    FormStatus["Draft"] = "draft";
    FormStatus["Active"] = "active";
})(FormStatus || (FormStatus = {}));
export var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["Created"] = "created";
    PaymentStatus["Processing"] = "processing";
    PaymentStatus["Succeeded"] = "succeeded";
    /** @deprecated */
    PaymentStatus["AwaitingTransfer"] = "awaiting_transfer";
    PaymentStatus["Failed"] = "failed";
    PaymentStatus["Expired"] = "expired";
})(PaymentStatus || (PaymentStatus = {}));
export var PostMailDeliveryStatus;
(function (PostMailDeliveryStatus) {
    PostMailDeliveryStatus["Draft"] = "draft";
    PostMailDeliveryStatus["Processing"] = "processing";
    PostMailDeliveryStatus["Sent"] = "sent";
    PostMailDeliveryStatus["Failed"] = "failed";
})(PostMailDeliveryStatus || (PostMailDeliveryStatus = {}));
export var DashboardPaymentStatus;
(function (DashboardPaymentStatus) {
    DashboardPaymentStatus["Processing"] = "Processing";
    DashboardPaymentStatus["Succeeded"] = "Succeeded";
    DashboardPaymentStatus["Failed"] = "Failed";
    DashboardPaymentStatus["Disputed"] = "Disputed";
    DashboardPaymentStatus["DisputeLost"] = "DisputeLost";
    DashboardPaymentStatus["Monthly"] = "Monthly";
    DashboardPaymentStatus["Yearly"] = "Yearly";
    DashboardPaymentStatus["Stopped"] = "Stopped";
    DashboardPaymentStatus["PastDue"] = "PastDue";
    DashboardPaymentStatus["Unprocessed"] = "Unprocessed";
    DashboardPaymentStatus["Incomplete"] = "Incomplete";
    DashboardPaymentStatus["OnHold"] = "OnHold";
})(DashboardPaymentStatus || (DashboardPaymentStatus = {}));
export var ExpectedAmountSize;
(function (ExpectedAmountSize) {
    ExpectedAmountSize["Small"] = "Small";
    ExpectedAmountSize["Medium"] = "Medium";
    ExpectedAmountSize["Big"] = "Big";
})(ExpectedAmountSize || (ExpectedAmountSize = {}));
